import React from 'react';
import styles from './DataTable.module.scss';
import { $t } from '../../../helpers/translator';
import Loader from '../Loader/Loader';
import _ from "lodash";
import { HiChevronDoubleLeft, HiChevronDoubleRight, HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { IoChevronForward, IoChevronDown, IoCaretDown, IoCaretUp } from "react-icons/io5";
import { FaFileExcel, FaFileExport } from "react-icons/fa";
import { AiFillWarning } from 'react-icons/ai';
import api from '../../../helpers/api';
import Modal from './../Modal/Modal';

class DataTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data ? this.props.data : null,
            headers: this.props.headers ? this.props.headers.map((h) => {
                if (
                    typeof h === 'object' &&
                    !Array.isArray(h) &&
                    h !== null
                ) {
                    h.exportable = h.exportable ? h.exportable : true;
                }

                return h;
            }).filter((h) => h !== false && h !== null) : null,
            pagination: this.props.pagination ? this.props.pagination : null,
            exportable: this.props.exportable !== undefined ? this.props.exportable : true,
            expandedRows: this.props.data && this.props.data.length ? new Array(this.props.data.length) : [],    //setting an array of flags
            exportLoading: false,
            export: null,
        };
    }

    async exportTable() {
        try {
            const url = this.props.apiUrl
            const exportableColumns = this.state.headers.filter((h) => h.exportable).map((h) => {
                return {
                    name: h.name,
                    id: h.accessor !== undefined ? h.accessor : h.id,
                }
            });

            const exportUrl = url.replace(/&(page|per_page)=[^&]*/gm, '') + `&export=true&columns=${btoa(JSON.stringify(exportableColumns))}`;
            this.setState({ exportLoading: true });
            const res = await api.get(exportUrl)
            this.setState({
                exportLoading: false,
                export: res.data.data
            });
        } catch (e) {
            this.setState({
                exportLoading: false,
                export: null
            });
            console.error(e)
        }
    }

    emitAction(key, value) {
        this.props.onAction({
            key: key,
            value: value
        });
    }

    toggleExpanded(k) {
        if (!this.props.childrenArrayName || !this.props.data[ k ][ this.props.childrenArrayName ].length) {
            return;
        }

        let expandedRows = this.state.expandedRows;
        expandedRows[ k ] = !expandedRows[ k ];

        this.setState({ expandedRows: expandedRows }, () => {
        });
    }

    renderTableRows() {
        let rowsArr = [];
        if (!this.props.data || !this.props.data.length) {
            return (
                <tr>
                    <td colSpan={ this.props.headers.length }>
                        <div className={ styles.noDataContainer } style={ {
                            padding: '10px 0',
                            textAlign: 'center'
                        } }>{ $t('global.general.noDataToDisplay') }</div>
                    </td>
                </tr>
            );
        }

        _.forEach(this.props.data, (row, rowK) => {
            let mainRow = (
                <tr
                    key={ rowK }
                    id={ `row-${rowK}` }
                    className={ `${styles[ 'row' ]} 
                    ${styles[ (rowK % 2 ? 'gray-bg' : 'bg-white') ]}  
                    ${styles[ (this.state.expandedRows[ rowK ] ? ' selected-row' : '') ]}` }
                >
                    { this.props.childrenArrayName ?
                        <td
                            className={ `${styles[ 'cell' ]} 
                            ${styles[ 'sticky-x' ]} 
                            ${styles[ (this.props.childrenArrayName && row[ this.props.childrenArrayName ].length ? 'pointer-cursor' : '') ]} 
                            ${styles[ (rowK % 2 ? 'gray-bg' : 'white-bg') ]}
                            ${styles[ (this.state.expandedRows[ rowK ] ? 'expanded-row' : 'collapsed-row') ]}` }
                            onClick={ () => this.toggleExpanded(rowK) }>
                            { this.props.childrenArrayName && row[ this.props.childrenArrayName ].length ?
                                <div>
                                    { this.state.expandedRows[ rowK ] ?
                                        // <Tooltip content={$t('global.general.collapse')}>
                                        <div>
                                            <IoChevronDown />
                                        </div>
                                        // </Tooltip>
                                        :
                                        // <Tooltip content={$t('global.general.expand')}>
                                        <IoChevronForward />
                                        // </Tooltip>
                                    }
                                </div>
                                :
                                ' ' }
                        </td>
                        :
                        null
                    }

                    { this.state.headers.map((header, k) => (
                        <td className={ `${styles[ 'cell' ]}` }
                            key={ k }
                            style={ header.style ? header.style : {} }
                            onClick={ () => this.emitAction('cell-main', {
                                header: header.id,
                                row: rowK
                            }) }>
                            { header.render !== undefined ? header.render(row[ header.id ], row) : row[ header.id ] }
                        </td>
                    )) }
                </tr>
            );

            rowsArr.push(mainRow);  //pushing main row

            if (this.props.childrenArrayName) {
                _.forEach(row[ this.props.childrenArrayName ], (child, childK) => {
                    let childRow = (
                        <tr key={ rowK + '-' + childK }
                            className={ `${styles[ 'row' ]} 
                            ${styles[ 'child-row' ]} 
                            ${styles[ (rowK % 2 ? 'gray-bg' : '') ]} 
                            ${styles[ (this.state.expandedRows[ rowK ] ? '' : 'hidden-tr') ]}` }
                        >
                            <td className={ `${styles[ 'cell' ]} 
                            ${styles[ 'sticky-x' ]} 
                            ${styles[ (rowK % 2 ? 'gray-bg' : 'white-bg') ]}` }
                            />
                            { this.state.headers.map((header, key) => (
                                <td className={ `${styles[ 'cell' ]}` }
                                    key={ key }
                                    onClick={ () => this.emitAction('cell-child', {
                                        header: header.id,
                                        row: rowK,
                                        child: childK
                                    }) }>
                                    { child[ header.id ] ? child[ header.id ] : ' ' }
                                </td>
                            )) }
                        </tr>
                    );
                    rowsArr.push(childRow);  //pushing child row
                });
            }
        });


        return rowsArr;
    }

    // componentDidUpdate(prevProps, prevState) {
    //     console.log(this.props)
    // }

    renderPagination() {
        if (!this.props.pagination || this.props.pagination.last_page === 1) {
            return null;
        }

        let numbers = [];
        let paginationNumbers = [];


        // adding all pagination numbers:
        for (let i = 1; i <= this.props.pagination.last_page; i++) {
            numbers.push(i);
        }

        //removing pagination numbers not to be displayed:
        if (this.props.pagination.last_page > 5) {
            for (let i = 0; i < numbers.length; i++) {
                let showAround = 1;
                if (this.props.pagination.current_page === 1 || this.props.pagination.current_page === this.props.pagination.last_page) {
                    showAround = 3
                }
                if (this.props.pagination.current_page === 2 || this.props.pagination.current_page === this.props.pagination.last_page - 1) {
                    showAround = 2
                }

                if (numbers[ i ] !== 1 &&
                    numbers[ i ] !== this.props.pagination.last_page &&
                    numbers[ i ] !== this.props.pagination.current_page &&
                    (
                        numbers[ i ] > this.props.pagination.current_page + showAround
                        ||
                        numbers[ i ] < this.props.pagination.current_page - showAround
                    )
                ) {
                    if (numbers[ i - 1 ] && numbers[ i - 1 ] !== '...') {
                        numbers[ i ] = '...';
                    } else {
                        numbers.splice(i--, 1)
                    }
                }
            }
        }

        _.forEach(numbers, (v, k) => {
            paginationNumbers.push(<div onClick={ () => this.changePage(v) }
                key={ k }
                className={ `${styles[ 'num' ]} ${styles[ (v === this.props.pagination.current_page ? 'selected-pg' : '') ]} ${styles[ (this.getIsPageClickable(v) ? 'pointer-cursor' : '') ]}` }

            >{ v }</div>)
        })


        return (
            <div className={ `${styles[ 'pagination-container' ]}` }>
                { this.props.pagination.last_page > 10 ?
                    <div className={ `${styles[ 'num' ]} ${styles[ (this.getIsPageClickable(this.props.pagination.current_page - 1) ? 'pointer-cursor' : 'grayed-out') ]}` }
                        onClick={ () => this.changePage(this.props.pagination.current_page - 10) }>
                        <HiChevronDoubleLeft /></div>
                    :
                    null
                }

                <div
                    className={ `${styles[ 'num' ]} ${styles[ (this.getIsPageClickable(this.props.pagination.current_page - 1) ? 'pointer-cursor' : 'grayed-out') ]}` }
                    onClick={ () => this.changePage(this.props.pagination.current_page - 1) }>
                    <HiChevronLeft />
                </div>

                { paginationNumbers }

                <div
                    className={ `${styles[ 'num' ]} ${styles[ (this.getIsPageClickable(this.props.pagination.current_page + 1) ? 'pointer-cursor' : 'grayed-out') ]}` }
                    onClick={ () => this.changePage(this.props.pagination.current_page + 1) }>
                    <HiChevronRight />
                </div>

                { this.props.pagination.last_page > 10 ?
                    <div className={ `${styles[ 'num' ]} ${styles[ (this.getIsPageClickable(this.props.pagination.current_page + 1) ? 'pointer-cursor' : 'grayed-out') ]}` }
                        onClick={ () => this.changePage(this.props.pagination.current_page + 10) }>
                        <HiChevronDoubleRight /></div>
                    :
                    null
                }
            </div>
        );
    }

    getIsPageClickable(page) {
        if (isNaN(page)) {
            return false;
        }

        return !(page > this.props.pagination.last_page || page < 1 || page === this.props.pagination.current_page);
    }

    changePage(pg) {
        pg = pg < 1 ? 1 : pg;
        pg = pg > this.props.pagination.last_page ? this.props.pagination.last_page : pg;

        if (!this.getIsPageClickable(pg)) {
            return;
        }

        this.emitAction('page', pg);
        this.setState({ expandedRows: new Array(this.props.pagination.per_page) });
    }

    render() {
        let fromC = this.props.pagination && this.props.pagination.from ? this.props.pagination.from : 0;
        let toC = this.props.pagination && this.props.pagination.to ? this.props.pagination.to : 0;
        let totalC = this.props.pagination && this.props.pagination.total ? this.props.pagination.total : 0;
        // let displayStr = $t('global.general.displayingOutOf', fromC, toC, totalC)
        let displayStr = $t('global.general.displayingOutOf', [ fromC, toC, totalC ]);

        return (
            <div className={ `${styles[ 'container' ]}` }>
                <Modal content={ <div style={ {
                    width: '350px',
                    maxWidth: '100%',
                    textAlign: 'center',
                    padding: '25px 0'
                } }>
                    { totalC > 9999 ? <div className={ styles.exportAlert }>
                        <AiFillWarning />
                        <p>
                            <b>Please Note!</b> Exports are limited to 10,000 records. Please use filters to narrow down your search.
                        </p>
                    </div> : <></> }
                    <h1>Export is Ready!</h1>
                    <p>Your export of { totalC } records is ready. Click the link below to download.</p>
                    <a href={ this.state.export !== null ? this.state.export.downloadUrl : '#' } className='alma-button'>Download File</a>
                </div> } onClose={ (e) => {
                    this.setState({ export: null })
                } } visible={ this.state.export !== null && !this.state.exportLoading } />
                { this.props.loading || this.state.exportLoading ?
                    <div className={ `${styles[ 'loader-container' ]}` }>
                        <div>
                            <Loader />
                            { this.state.exportLoading && <div>Generating Export..</div> }
                        </div>
                    </div>
                    :
                    null
                }
                <div className={ `${styles[ 'header-row' ]} d-flex align-items-center justify-content-between` }>
                    {
                        this.props.pagination ?
                            <>
                                <div style={ { textAlign: 'start' } }>
                                    { displayStr }
                                </div>
                                { (this.state.exportable && this.props.apiUrl) && <div style={ { textAlign: 'end' } }>
                                    <button type='button' onClick={ (e) => { this.exportTable() } } className={ styles.exportButton }><FaFileExcel /> Export Table</button>
                                </div> }
                            </>

                            : null
                    }
                </div>

                <div className={ `${styles[ 'table-container' ]}` } style={ {
                    maxHeight: this.props.maxHeight ? this.props.maxHeight : '80vh',
                } }>
                    <table className={ `${styles[ 'main-table' ]}` }>
                        <tbody>
                            <tr className={ `${styles[ 'headings-row' ]} ${styles[ 'row' ]}` }>
                                { this.props.childrenArrayName ?
                                    <td style={ { background: '#F6F6F6' } } />
                                    :
                                    null
                                }

                                { this.state.headers.map((header, ktd) => (
                                    <td
                                        className={ `${styles[ 'cell' ]} ${styles[ (header.clickable ? 'pointer-cursor' : '') ]}` }
                                        key={ ktd }
                                        onClick={ () => (header.clickable ? this.emitAction('header', header.id) : null) }>
                                        <div className={ `${styles[ 'header-td' ]}` }>
                                            {
                                                <div className={ `${styles[ 'sorted-tri' ]}` }>
                                                    {
                                                        this.props.sorted && this.props.sorted.id === header.id ?
                                                            <div>
                                                                {
                                                                    this.props.sorted.desc || (this.props.sorted.order && this.props.sorted.order === 'desc') ?
                                                                        <IoCaretDown />
                                                                        :
                                                                        <IoCaretUp />
                                                                }
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            }
                                            <div className={ `${styles[ 'header-name' ]}` }>{ header.name }</div>
                                        </div>
                                    </td>
                                )) }

                            </tr>

                            { this.renderTableRows() }
                        </tbody>
                    </table>
                </div>
                { this.renderPagination() }
            </div>
        );
    }
}

export default DataTable;
